/* tslint:disable */
/* eslint-disable */
/**
 * CGN Onboarding Portal
 * Carta Giovani Nazionale Onboarding Portal
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ActiveAgreement
 */
export interface ActiveAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'fullAddress': string;
    /**
     * 
     * @type {Coordinates}
     * @memberof Address
     */
    'coordinates'?: Coordinates;
}
/**
 * 
 * @export
 * @interface Agreement
 */
export interface Agreement {
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'id': string;
    /**
     * 
     * @type {AgreementState}
     * @memberof Agreement
     */
    'state': AgreementState;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<CompletedStep>}
     * @memberof Agreement
     */
    'completedSteps': Array<CompletedStep>;
    /**
     * 
     * @type {EntityType}
     * @memberof Agreement
     */
    'entityType'?: EntityType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AgreementState = {
    DraftAgreement: 'DraftAgreement',
    PendingAgreement: 'PendingAgreement',
    ApprovedAgreement: 'ApprovedAgreement',
    RejectedAgreement: 'RejectedAgreement',
    ActiveAgreement: 'ActiveAgreement',
    ExpiredAgreement: 'ExpiredAgreement',
    InactiveAgreement: 'InactiveAgreement',
    TerminationReminderSentAgreement: 'TerminationReminderSentAgreement',
    TerminationInProgressAgreement: 'TerminationInProgressAgreement',
    TerminatedAgreement: 'TerminatedAgreement'
} as const;

export type AgreementState = typeof AgreementState[keyof typeof AgreementState];


/**
 * 
 * @export
 * @interface ApiTokens
 */
export interface ApiTokens {
    /**
     * 
     * @type {string}
     * @memberof ApiTokens
     */
    'primaryToken': string;
    /**
     * 
     * @type {string}
     * @memberof ApiTokens
     */
    'secondaryToken': string;
}
/**
 * 
 * @export
 * @interface ApprovedAgreement
 */
export interface ApprovedAgreement extends Agreement {
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof ApprovedAgreement
     */
    'firstDiscountPublishingDate'?: string;
}


/**
 * 
 * @export
 * @interface BothChannels
 */
export interface BothChannels extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof BothChannels
     */
    'websiteUrl': string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof BothChannels
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {boolean}
     * @memberof BothChannels
     */
    'allNationalAddresses'?: boolean;
    /**
     * 
     * @type {DiscountCodeType}
     * @memberof BothChannels
     */
    'discountCodeType'?: DiscountCodeType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BucketCodeLoadStatus = {
    Pending: 'pending',
    Running: 'running',
    Finished: 'finished',
    Failed: 'failed'
} as const;

export type BucketCodeLoadStatus = typeof BucketCodeLoadStatus[keyof typeof BucketCodeLoadStatus];


/**
 * 
 * @export
 * @interface BucketLoad
 */
export interface BucketLoad {
    /**
     * 
     * @type {string}
     * @memberof BucketLoad
     */
    'uid': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CompletedStep = {
    Profile: 'Profile',
    Discount: 'Discount',
    Document: 'Document'
} as const;

export type CompletedStep = typeof CompletedStep[keyof typeof CompletedStep];


/**
 * 
 * @export
 * @interface Coordinates
 */
export interface Coordinates {
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    'latitude': number;
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    'longitude': number;
}
/**
 * 
 * @export
 * @interface CreateDiscount
 */
export interface CreateDiscount {
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'name_en': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'name_de': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'description_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'description_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDiscount
     */
    'discount'?: number;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof CreateDiscount
     */
    'productCategories': Array<ProductCategory>;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'condition_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'condition_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'staticCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDiscount
     */
    'visibleOnEyca'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'eycaLandingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'landingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'landingPageReferrer'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'lastBucketCodeLoadUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'lastBucketCodeLoadFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDiscount
     */
    'discountUrl'?: string;
}
/**
 * 
 * @export
 * @interface CreateProfile
 */
export interface CreateProfile {
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'name_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'taxCodeOrVat': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'pecAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'legalOffice': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'telephoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'legalRepresentativeFullName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'legalRepresentativeTaxCode': string;
    /**
     * 
     * @type {CreateReferent}
     * @memberof CreateProfile
     */
    'referent': CreateReferent;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'description_en': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfile
     */
    'description_de': string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof CreateProfile
     */
    'salesChannel': SalesChannel;
    /**
     * 
     * @type {Array<CreateReferent>}
     * @memberof CreateProfile
     */
    'secondaryReferents'?: Array<CreateReferent>;
}
/**
 * 
 * @export
 * @interface CreateReferent
 */
export interface CreateReferent {
    /**
     * 
     * @type {string}
     * @memberof CreateReferent
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferent
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferent
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferent
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateReferent
     */
    'telephoneNumber': string;
}
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'agreementId': string;
    /**
     * 
     * @type {DiscountState}
     * @memberof Discount
     */
    'state': DiscountState;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name_en': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'name_de': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'description_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'description_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    'discount'?: number;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof Discount
     */
    'productCategories': Array<ProductCategory>;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'condition_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'condition_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'staticCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Discount
     */
    'visibleOnEyca'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'suspendedReasonMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'eycaLandingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'landingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'landingPageReferrer'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'lastBucketCodeLoadUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'lastBucketCodeLoadFileName'?: string;
    /**
     * 
     * @type {BucketCodeLoadStatus}
     * @memberof Discount
     */
    'lastBucketCodeLoadStatus'?: BucketCodeLoadStatus;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'discountUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    'testFailureReason'?: string;
}


/**
 * 
 * @export
 * @interface DiscountBucketCodeLoadingProgess
 */
export interface DiscountBucketCodeLoadingProgess {
    /**
     * 
     * @type {number}
     * @memberof DiscountBucketCodeLoadingProgess
     */
    'loaded': number;
    /**
     * 
     * @type {number}
     * @memberof DiscountBucketCodeLoadingProgess
     */
    'percent': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountCodeType = {
    Static: 'Static',
    Api: 'API',
    LandingPage: 'LandingPage',
    Bucket: 'Bucket'
} as const;

export type DiscountCodeType = typeof DiscountCodeType[keyof typeof DiscountCodeType];


/**
 * 
 * @export
 * @enum {string}
 */

export const DiscountState = {
    Draft: 'draft',
    Published: 'published',
    Suspended: 'suspended',
    Expired: 'expired',
    TestPending: 'test_pending',
    TestPassed: 'test_passed',
    TestFailed: 'test_failed'
} as const;

export type DiscountState = typeof DiscountState[keyof typeof DiscountState];


/**
 * 
 * @export
 * @interface Discounts
 */
export interface Discounts {
    /**
     * 
     * @type {Array<Discount>}
     * @memberof Discounts
     */
    'items': Array<Discount>;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentType': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'documentTimestamp': string;
}
/**
 * 
 * @export
 * @interface Documents
 */
export interface Documents {
    /**
     * 
     * @type {Array<Document>}
     * @memberof Documents
     */
    'items': Array<Document>;
}
/**
 * 
 * @export
 * @interface DraftAgreement
 */
export interface DraftAgreement extends Agreement {
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EntityType = {
    Private: 'Private',
    PublicAdministration: 'PublicAdministration'
} as const;

export type EntityType = typeof EntityType[keyof typeof EntityType];


/**
 * A payload used for error responses.
 * @export
 * @interface ErrorCode
 */
export interface ErrorCode {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ErrorCodeEnum = {
    CannotGetBucketCodeForDiscountNotTestPendingOrNotPublished: 'CANNOT_GET_BUCKET_CODE_FOR_DISCOUNT_NOT_TEST_PENDING_OR_NOT_PUBLISHED',
    VisibleOnEycaNotConsistentWithUrl: 'VISIBLE_ON_EYCA_NOT_CONSISTENT_WITH_URL',
    CannotHaveEmptyStaticCodeForProfileWithStaticCode: 'CANNOT_HAVE_EMPTY_STATIC_CODE_FOR_PROFILE_WITH_STATIC_CODE',
    CannotHaveEmptyLandingPageUrlForProfileLandingPage: 'CANNOT_HAVE_EMPTY_LANDING_PAGE_URL_FOR_PROFILE_LANDING_PAGE',
    CannotProceedWithDiscountWithBucketLoadInProgress: 'CANNOT_PROCEED_WITH_DISCOUNT_WITH_BUCKET_LOAD_IN_PROGRESS',
    CannotProceedWithDiscountWithNotApprovedAgreement: 'CANNOT_PROCEED_WITH_DISCOUNT_WITH_NOT_APPROVED_AGREEMENT',
    CannotPublishDiscountForTerminationInProgressAgreement: 'CANNOT_PUBLISH_DISCOUNT_FOR_TERMINATION_IN_PROGRESS_AGREEMENT',
    CannotProceedWithSuspendedDiscount: 'CANNOT_PROCEED_WITH_SUSPENDED_DISCOUNT',
    CannotProceedWithExpiredDiscount: 'CANNOT_PROCEED_WITH_EXPIRED_DISCOUNT',
    CannotProceedWithOnlineDiscountWithNotPassedTest: 'CANNOT_PROCEED_WITH_ONLINE_DISCOUNT_WITH_NOT_PASSED_TEST',
    MaxNumberOfPublishableDiscountsReached: 'MAX_NUMBER_OF_PUBLISHABLE_DISCOUNTS_REACHED',
    DiscountCannotHaveMoreThanTwoCategories: 'DISCOUNT_CANNOT_HAVE_MORE_THAN_TWO_CATEGORIES',
    AgreementNotApprovableForWrongMandatoryDocuments: 'AGREEMENT_NOT_APPROVABLE_FOR_WRONG_MANDATORY_DOCUMENTS',
    AgreementNotFound: 'AGREEMENT_NOT_FOUND',
    DiscountNotFound: 'DISCOUNT_NOT_FOUND',
    ProfileNotFound: 'PROFILE_NOT_FOUND',
    DocumentNotFound: 'DOCUMENT_NOT_FOUND',
    DocumentTypeNotValid: 'DOCUMENT_TYPE_NOT_VALID',
    DiscountNotRelatedToAgreementProvided: 'DISCOUNT_NOT_RELATED_TO_AGREEMENT_PROVIDED',
    CannotTestDiscountsWithOfflineMerchants: 'CANNOT_TEST_DISCOUNTS_WITH_OFFLINE_MERCHANTS',
    CannotUnpublishDiscountNotPublished: 'CANNOT_UNPUBLISH_DISCOUNT_NOT_PUBLISHED',
    CannotSuspendDiscountNotPublished: 'CANNOT_SUSPEND_DISCOUNT_NOT_PUBLISHED',
    DiscountCannotReferenceToMissingBucketFileForDiscountWithBucket: 'DISCOUNT_CANNOT_REFERENCE_TO_MISSING_BUCKET_FILE_FOR_DISCOUNT_WITH_BUCKET',
    CannotSetDiscountStateForDiscountNotInTestPending: 'CANNOT_SET_DISCOUNT_STATE_FOR_DISCOUNT_NOT_IN_TEST_PENDING',
    CannotGetBucketCodeForDiscountNotInTestPending: 'CANNOT_GET_BUCKET_CODE_FOR_DISCOUNT_NOT_IN_TEST_PENDING',
    CannotGetBucketCodeForDiscountNoBucket: 'CANNOT_GET_BUCKET_CODE_FOR_DISCOUNT_NO_BUCKET',
    CannotLoadBucketCodeForDiscountNoBucket: 'CANNOT_LOAD_BUCKET_CODE_FOR_DISCOUNT_NO_BUCKET',
    MaxAllowedBucketCodeLengthNotRespected: 'MAX_ALLOWED_BUCKET_CODE_LENGTH_NOT_RESPECTED',
    BucketCodesMustBeAlphanumWithAtLeastOneDigitAndOneChar: 'BUCKET_CODES_MUST_BE_ALPHANUM_WITH_AT_LEAST_ONE_DIGIT_AND_ONE_CHAR',
    NotAllowedSpecialChars: 'NOT_ALLOWED_SPECIAL_CHARS',
    OneOrMoreCodesAreNotValid: 'ONE_OR_MORE_CODES_ARE_NOT_VALID',
    CannotProceedAgreementNotInPending: 'CANNOT_PROCEED_AGREEMENT_NOT_IN_PENDING',
    AgreementNotAssignedToCurrentUser: 'AGREEMENT_NOT_ASSIGNED_TO_CURRENT_USER',
    MandatoryDocumentAreMissing: 'MANDATORY_DOCUMENT_ARE_MISSING',
    AgreementAlreadyAssignedToCurrentUser: 'AGREEMENT_ALREADY_ASSIGNED_TO_CURRENT_USER',
    AgreementNoLongerAssigned: 'AGREEMENT_NO_LONGER_ASSIGNED',
    AgreementUserNotFound: 'AGREEMENT_USER_NOT_FOUND',
    CannotRetrieveTokenForProfileNotApi: 'CANNOT_RETRIEVE_TOKEN_FOR_PROFILE_NOT_API',
    TokenParameterNotValid: 'TOKEN_PARAMETER_NOT_VALID',
    PdfNameOrExtensionNotValid: 'PDF_NAME_OR_EXTENSION_NOT_VALID',
    PdfRenderingError: 'PDF_RENDERING_ERROR',
    CsvNameOrExtensionNotValid: 'CSV_NAME_OR_EXTENSION_NOT_VALID',
    CsvDataNotValid: 'CSV_DATA_NOT_VALID',
    ImageDataNotValid: 'IMAGE_DATA_NOT_VALID',
    ImageNameOrExtensionNotValid: 'IMAGE_NAME_OR_EXTENSION_NOT_VALID',
    ImageDimensionNotValid: 'IMAGE_DIMENSION_NOT_VALID',
    ImageAzureUploadError: 'IMAGE_AZURE_UPLOAD_ERROR',
    AdhesionDocumentNotRequiredForPa: 'ADHESION_DOCUMENT_NOT_REQUIRED_FOR_PA',
    CannotUpdateDiscountBucketWhileProcessingIsRunning: 'CANNOT_UPDATE_DISCOUNT_BUCKET_WHILE_PROCESSING_IS_RUNNING',
    CannotLoadBucketForNotRespectedMinimumBound: 'CANNOT_LOAD_BUCKET_FOR_NOT_RESPECTED_MINIMUM_BOUND',
    ProfileAlreadyExistsForAgreementProvided: 'PROFILE_ALREADY_EXISTS_FOR_AGREEMENT_PROVIDED',
    CannotProceedWithDiscountWithEmptyBucket: 'CANNOT_PROCEED_WITH_DISCOUNT_WITH_EMPTY_BUCKET',
    CannotRetrieveBucketCodeFromDiscountWithEmptyBucket: 'CANNOT_RETRIEVE_BUCKET_CODE_FROM_DISCOUNT_WITH_EMPTY_BUCKET'
} as const;

export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];


/**
 * 
 * @export
 * @interface ExpiredAgreement
 */
export interface ExpiredAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface GeolocationToken
 */
export interface GeolocationToken {
    /**
     * 
     * @type {string}
     * @memberof GeolocationToken
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface HelpRequest
 */
export interface HelpRequest {
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'category': HelpRequestCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'topic'?: string;
    /**
     * 
     * @type {string}
     * @memberof HelpRequest
     */
    'message': string;
}

export const HelpRequestCategoryEnum = {
    Access: 'Access',
    DataFilling: 'DataFilling',
    Discounts: 'Discounts',
    Documents: 'Documents',
    TechnicalProblem: 'TechnicalProblem',
    CgnOwnerReporting: 'CgnOwnerReporting',
    Suggestions: 'Suggestions',
    Other: 'Other'
} as const;

export type HelpRequestCategoryEnum = typeof HelpRequestCategoryEnum[keyof typeof HelpRequestCategoryEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ImageErrorCode = {
    InvalidImageType: 'INVALID_IMAGE_TYPE',
    InvalidDimension: 'INVALID_DIMENSION',
    Generic: 'GENERIC',
    ImageSizeExceeded: 'IMAGE_SIZE_EXCEEDED'
} as const;

export type ImageErrorCode = typeof ImageErrorCode[keyof typeof ImageErrorCode];


/**
 * 
 * @export
 * @interface InactiveAgreement
 */
export interface InactiveAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface OfflineChannel
 */
export interface OfflineChannel extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof OfflineChannel
     */
    'websiteUrl'?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof OfflineChannel
     */
    'addresses': Array<Address>;
    /**
     * 
     * @type {boolean}
     * @memberof OfflineChannel
     */
    'allNationalAddresses'?: boolean;
}


/**
 * 
 * @export
 * @interface OnlineChannel
 */
export interface OnlineChannel extends SalesChannel {
    /**
     * 
     * @type {string}
     * @memberof OnlineChannel
     */
    'websiteUrl': string;
    /**
     * 
     * @type {DiscountCodeType}
     * @memberof OnlineChannel
     */
    'discountCodeType': DiscountCodeType;
}


/**
 * 
 * @export
 * @interface Organization
 */
export interface Organization {
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organization_name': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'organization_fiscal_code': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Organization
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface Organizations
 */
export interface Organizations {
    /**
     * 
     * @type {Array<Organization>}
     * @memberof Organizations
     */
    'items': Array<Organization>;
}
/**
 * 
 * @export
 * @interface PendingAgreement
 */
export interface PendingAgreement extends Agreement {
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductCategory = {
    BankingServices: 'BankingServices',
    CultureAndEntertainment: 'CultureAndEntertainment',
    Health: 'Health',
    Home: 'Home',
    JobOffers: 'JobOffers',
    Learning: 'Learning',
    Sports: 'Sports',
    SustainableMobility: 'SustainableMobility',
    TelephonyAndInternet: 'TelephonyAndInternet',
    Travelling: 'Travelling'
} as const;

export type ProductCategory = typeof ProductCategory[keyof typeof ProductCategory];


/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'taxCodeOrVat': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'pecAddress': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'legalOffice': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'telephoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'legalRepresentativeFullName': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'legalRepresentativeTaxCode': string;
    /**
     * 
     * @type {Referent}
     * @memberof Profile
     */
    'referent': Referent;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'description_en': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'description_de': string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof Profile
     */
    'salesChannel': SalesChannel;
    /**
     * 
     * @type {Array<Referent>}
     * @memberof Profile
     */
    'secondaryReferents'?: Array<Referent>;
}
/**
 * 
 * @export
 * @interface Referent
 */
export interface Referent {
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof Referent
     */
    'telephoneNumber': string;
}
/**
 * 
 * @export
 * @interface RejectedAgreement
 */
export interface RejectedAgreement extends Agreement {
    /**
     * 
     * @type {string}
     * @memberof RejectedAgreement
     */
    'reasonMessage': string;
}


/**
 * 
 * @export
 * @interface SalesChannel
 */
export interface SalesChannel {
    /**
     * 
     * @type {SalesChannelType}
     * @memberof SalesChannel
     */
    'channelType': SalesChannelType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SalesChannelType = {
    OnlineChannel: 'OnlineChannel',
    OfflineChannel: 'OfflineChannel',
    BothChannels: 'BothChannels'
} as const;

export type SalesChannelType = typeof SalesChannelType[keyof typeof SalesChannelType];


/**
 * 
 * @export
 * @interface TerminatedAgreement
 */
export interface TerminatedAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface TerminationInProgressAgreement
 */
export interface TerminationInProgressAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface TerminationReminderSentAgreement
 */
export interface TerminationReminderSentAgreement extends ApprovedAgreement {
}


/**
 * 
 * @export
 * @interface UpdateDiscount
 */
export interface UpdateDiscount {
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'name_en': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'name_de': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'description_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'description_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDiscount
     */
    'discount'?: number;
    /**
     * 
     * @type {Array<ProductCategory>}
     * @memberof UpdateDiscount
     */
    'productCategories': Array<ProductCategory>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'condition'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'condition_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'condition_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'staticCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDiscount
     */
    'visibleOnEyca'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'eycaLandingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'landingPageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'landingPageReferrer'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'lastBucketCodeLoadUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'lastBucketCodeLoadFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscount
     */
    'discountUrl'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProfile
 */
export interface UpdateProfile {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'name_en'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'name_de'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'pecAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'legalOffice': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'telephoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'legalRepresentativeFullName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'legalRepresentativeTaxCode': string;
    /**
     * 
     * @type {UpdateReferent}
     * @memberof UpdateProfile
     */
    'referent': UpdateReferent;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'description_en': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfile
     */
    'description_de': string;
    /**
     * 
     * @type {SalesChannel}
     * @memberof UpdateProfile
     */
    'salesChannel': SalesChannel;
    /**
     * 
     * @type {Array<UpdateReferent>}
     * @memberof UpdateProfile
     */
    'secondaryReferents'?: Array<UpdateReferent>;
}
/**
 * 
 * @export
 * @interface UpdateReferent
 */
export interface UpdateReferent {
    /**
     * 
     * @type {string}
     * @memberof UpdateReferent
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferent
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferent
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferent
     */
    'emailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReferent
     */
    'telephoneNumber': string;
}
/**
 * 
 * @export
 * @interface UploadedImage
 */
export interface UploadedImage {
    /**
     * 
     * @type {string}
     * @memberof UploadedImage
     */
    'imageUrl': string;
}

/**
 * AgreementApi - axios parameter creator
 * @export
 */
export const AgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create an agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreement: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request agreement approval
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestApproval: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('requestApproval', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/approval`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an image
         * @param {string} agreementId Agreement id
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (agreementId: string, image: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('uploadImage', 'agreementId', agreementId)
            // verify required parameter 'image' is not null or undefined
            assertParamExists('uploadImage', 'image', image)
            const localVarPath = `/agreements/{agreementId}/images`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementApi - functional programming interface
 * @export
 */
export const AgreementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create an agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgreement(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgreement(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.createAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request agreement approval
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestApproval(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestApproval(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.requestApproval']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an image
         * @param {string} agreementId Agreement id
         * @param {File} image 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(agreementId: string, image: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(agreementId, image, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.uploadImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementApi - factory interface
 * @export
 */
export const AgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementApiFp(configuration)
    return {
        /**
         * 
         * @summary Create an agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreement(options?: RawAxiosRequestConfig): AxiosPromise<Agreement> {
            return localVarFp.createAgreement(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request agreement approval
         * @param {AgreementApiRequestApprovalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestApproval(requestParameters: AgreementApiRequestApprovalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestApproval(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an image
         * @param {AgreementApiUploadImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(requestParameters: AgreementApiUploadImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadedImage> {
            return localVarFp.uploadImage(requestParameters.agreementId, requestParameters.image, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for requestApproval operation in AgreementApi.
 * @export
 * @interface AgreementApiRequestApprovalRequest
 */
export interface AgreementApiRequestApprovalRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiRequestApproval
     */
    readonly agreementId: string
}

/**
 * Request parameters for uploadImage operation in AgreementApi.
 * @export
 * @interface AgreementApiUploadImageRequest
 */
export interface AgreementApiUploadImageRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof AgreementApiUploadImage
     */
    readonly agreementId: string

    /**
     * 
     * @type {File}
     * @memberof AgreementApiUploadImage
     */
    readonly image: File
}

/**
 * AgreementApi - object-oriented interface
 * @export
 * @class AgreementApi
 * @extends {BaseAPI}
 */
export class AgreementApi extends BaseAPI {
    /**
     * 
     * @summary Create an agreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public createAgreement(options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).createAgreement(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request agreement approval
     * @param {AgreementApiRequestApprovalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public requestApproval(requestParameters: AgreementApiRequestApprovalRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).requestApproval(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an image
     * @param {AgreementApiUploadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public uploadImage(requestParameters: AgreementApiUploadImageRequest, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).uploadImage(requestParameters.agreementId, requestParameters.image, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApiTokenApi - axios parameter creator
 * @export
 */
export const ApiTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve or Create API Tokens
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getTokens', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/api-tokens`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Regenerate Api Token
         * @param {string} agreementId Agreement id
         * @param {RegenerateTokenTokenTypeEnum} tokenType Token type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateToken: async (agreementId: string, tokenType: RegenerateTokenTokenTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('regenerateToken', 'agreementId', agreementId)
            // verify required parameter 'tokenType' is not null or undefined
            assertParamExists('regenerateToken', 'tokenType', tokenType)
            const localVarPath = `/agreements/{agreementId}/api-tokens/{tokenType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"tokenType"}}`, encodeURIComponent(String(tokenType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiTokenApi - functional programming interface
 * @export
 */
export const ApiTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Retrieve or Create API Tokens
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTokens(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTokens>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTokens(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.getTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Regenerate Api Token
         * @param {string} agreementId Agreement id
         * @param {RegenerateTokenTokenTypeEnum} tokenType Token type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateToken(agreementId: string, tokenType: RegenerateTokenTokenTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiTokens>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateToken(agreementId, tokenType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiTokenApi.regenerateToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiTokenApi - factory interface
 * @export
 */
export const ApiTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Retrieve or Create API Tokens
         * @param {ApiTokenApiGetTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTokens(requestParameters: ApiTokenApiGetTokensRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTokens> {
            return localVarFp.getTokens(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Regenerate Api Token
         * @param {ApiTokenApiRegenerateTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateToken(requestParameters: ApiTokenApiRegenerateTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiTokens> {
            return localVarFp.regenerateToken(requestParameters.agreementId, requestParameters.tokenType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getTokens operation in ApiTokenApi.
 * @export
 * @interface ApiTokenApiGetTokensRequest
 */
export interface ApiTokenApiGetTokensRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof ApiTokenApiGetTokens
     */
    readonly agreementId: string
}

/**
 * Request parameters for regenerateToken operation in ApiTokenApi.
 * @export
 * @interface ApiTokenApiRegenerateTokenRequest
 */
export interface ApiTokenApiRegenerateTokenRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof ApiTokenApiRegenerateToken
     */
    readonly agreementId: string

    /**
     * Token type
     * @type {'primary' | 'secondary'}
     * @memberof ApiTokenApiRegenerateToken
     */
    readonly tokenType: RegenerateTokenTokenTypeEnum
}

/**
 * ApiTokenApi - object-oriented interface
 * @export
 * @class ApiTokenApi
 * @extends {BaseAPI}
 */
export class ApiTokenApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve or Create API Tokens
     * @param {ApiTokenApiGetTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public getTokens(requestParameters: ApiTokenApiGetTokensRequest, options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).getTokens(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Regenerate Api Token
     * @param {ApiTokenApiRegenerateTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiTokenApi
     */
    public regenerateToken(requestParameters: ApiTokenApiRegenerateTokenRequest, options?: RawAxiosRequestConfig) {
        return ApiTokenApiFp(this.configuration).regenerateToken(requestParameters.agreementId, requestParameters.tokenType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RegenerateTokenTokenTypeEnum = {
    Primary: 'primary',
    Secondary: 'secondary'
} as const;
export type RegenerateTokenTokenTypeEnum = typeof RegenerateTokenTokenTypeEnum[keyof typeof RegenerateTokenTokenTypeEnum];


/**
 * BucketApi - axios parameter creator
 * @export
 */
export const BucketApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary uploadBucket
         * @param {string} agreementId Agreement id
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBucket: async (agreementId: string, document: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('uploadBucket', 'agreementId', agreementId)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('uploadBucket', 'document', document)
            const localVarPath = `/agreements/{agreementId}/discounts/bucket`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BucketApi - functional programming interface
 * @export
 */
export const BucketApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BucketApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary uploadBucket
         * @param {string} agreementId Agreement id
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBucket(agreementId: string, document: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BucketLoad>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBucket(agreementId, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BucketApi.uploadBucket']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BucketApi - factory interface
 * @export
 */
export const BucketApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BucketApiFp(configuration)
    return {
        /**
         * 
         * @summary uploadBucket
         * @param {BucketApiUploadBucketRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBucket(requestParameters: BucketApiUploadBucketRequest, options?: RawAxiosRequestConfig): AxiosPromise<BucketLoad> {
            return localVarFp.uploadBucket(requestParameters.agreementId, requestParameters.document, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for uploadBucket operation in BucketApi.
 * @export
 * @interface BucketApiUploadBucketRequest
 */
export interface BucketApiUploadBucketRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof BucketApiUploadBucket
     */
    readonly agreementId: string

    /**
     * 
     * @type {File}
     * @memberof BucketApiUploadBucket
     */
    readonly document: File
}

/**
 * BucketApi - object-oriented interface
 * @export
 * @class BucketApi
 * @extends {BaseAPI}
 */
export class BucketApi extends BaseAPI {
    /**
     * 
     * @summary uploadBucket
     * @param {BucketApiUploadBucketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BucketApi
     */
    public uploadBucket(requestParameters: BucketApiUploadBucketRequest, options?: RawAxiosRequestConfig) {
        return BucketApiFp(this.configuration).uploadBucket(requestParameters.agreementId, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountApi - axios parameter creator
 * @export
 */
export const DiscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a discount
         * @param {string} agreementId Agreement id
         * @param {CreateDiscount} discount Discount to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount: async (agreementId: string, discount: CreateDiscount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createDiscount', 'agreementId', agreementId)
            // verify required parameter 'discount' is not null or undefined
            assertParamExists('createDiscount', 'discount', discount)
            const localVarPath = `/agreements/{agreementId}/discounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscount: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('deleteDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('deleteDiscount', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get discount by id
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountById: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDiscountById', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('getDiscountById', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of discounts
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounts: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDiscounts', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/discounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDiscount: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('publishDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('publishDiscount', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}/publishing`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a discount ready to be tested
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testDiscount: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('testDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('testDiscount', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}/testing`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unpublish a discount making it a draft
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishDiscount: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('unpublishDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('unpublishDiscount', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}/unpublishing`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {UpdateDiscount} discount Discount to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscount: async (agreementId: string, discountId: string, discount: UpdateDiscount, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('updateDiscount', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('updateDiscount', 'discountId', discountId)
            // verify required parameter 'discount' is not null or undefined
            assertParamExists('updateDiscount', 'discount', discount)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(discount, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountApi - functional programming interface
 * @export
 */
export const DiscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a discount
         * @param {string} agreementId Agreement id
         * @param {CreateDiscount} discount Discount to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiscount(agreementId: string, discount: CreateDiscount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiscount(agreementId, discount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.createDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiscount(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiscount(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.deleteDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get discount by id
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountById(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountById(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.getDiscountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of discounts
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscounts(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscounts(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.getDiscounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Publish a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDiscount(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDiscount(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.publishDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set a discount ready to be tested
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testDiscount(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testDiscount(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.testDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unpublish a discount making it a draft
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpublishDiscount(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpublishDiscount(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.unpublishDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {UpdateDiscount} discount Discount to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiscount(agreementId: string, discountId: string, discount: UpdateDiscount, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Discount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiscount(agreementId, discountId, discount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.updateDiscount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountApi - factory interface
 * @export
 */
export const DiscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a discount
         * @param {DiscountApiCreateDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscount(requestParameters: DiscountApiCreateDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.createDiscount(requestParameters.agreementId, requestParameters.discount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a discount
         * @param {DiscountApiDeleteDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscount(requestParameters: DiscountApiDeleteDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get discount by id
         * @param {DiscountApiGetDiscountByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountById(requestParameters: DiscountApiGetDiscountByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.getDiscountById(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of discounts
         * @param {DiscountApiGetDiscountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscounts(requestParameters: DiscountApiGetDiscountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Discounts> {
            return localVarFp.getDiscounts(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publish a discount
         * @param {DiscountApiPublishDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDiscount(requestParameters: DiscountApiPublishDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.publishDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a discount ready to be tested
         * @param {DiscountApiTestDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testDiscount(requestParameters: DiscountApiTestDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unpublish a discount making it a draft
         * @param {DiscountApiUnpublishDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpublishDiscount(requestParameters: DiscountApiUnpublishDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unpublishDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a discount
         * @param {DiscountApiUpdateDiscountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscount(requestParameters: DiscountApiUpdateDiscountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Discount> {
            return localVarFp.updateDiscount(requestParameters.agreementId, requestParameters.discountId, requestParameters.discount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiCreateDiscountRequest
 */
export interface DiscountApiCreateDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiCreateDiscount
     */
    readonly agreementId: string

    /**
     * Discount to create
     * @type {CreateDiscount}
     * @memberof DiscountApiCreateDiscount
     */
    readonly discount: CreateDiscount
}

/**
 * Request parameters for deleteDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiDeleteDiscountRequest
 */
export interface DiscountApiDeleteDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiDeleteDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiDeleteDiscount
     */
    readonly discountId: string
}

/**
 * Request parameters for getDiscountById operation in DiscountApi.
 * @export
 * @interface DiscountApiGetDiscountByIdRequest
 */
export interface DiscountApiGetDiscountByIdRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiGetDiscountById
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiGetDiscountById
     */
    readonly discountId: string
}

/**
 * Request parameters for getDiscounts operation in DiscountApi.
 * @export
 * @interface DiscountApiGetDiscountsRequest
 */
export interface DiscountApiGetDiscountsRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiGetDiscounts
     */
    readonly agreementId: string
}

/**
 * Request parameters for publishDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiPublishDiscountRequest
 */
export interface DiscountApiPublishDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiPublishDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiPublishDiscount
     */
    readonly discountId: string
}

/**
 * Request parameters for testDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiTestDiscountRequest
 */
export interface DiscountApiTestDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiTestDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiTestDiscount
     */
    readonly discountId: string
}

/**
 * Request parameters for unpublishDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiUnpublishDiscountRequest
 */
export interface DiscountApiUnpublishDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiUnpublishDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiUnpublishDiscount
     */
    readonly discountId: string
}

/**
 * Request parameters for updateDiscount operation in DiscountApi.
 * @export
 * @interface DiscountApiUpdateDiscountRequest
 */
export interface DiscountApiUpdateDiscountRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountApiUpdateDiscount
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountApiUpdateDiscount
     */
    readonly discountId: string

    /**
     * Discount to update
     * @type {UpdateDiscount}
     * @memberof DiscountApiUpdateDiscount
     */
    readonly discount: UpdateDiscount
}

/**
 * DiscountApi - object-oriented interface
 * @export
 * @class DiscountApi
 * @extends {BaseAPI}
 */
export class DiscountApi extends BaseAPI {
    /**
     * 
     * @summary Create a discount
     * @param {DiscountApiCreateDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public createDiscount(requestParameters: DiscountApiCreateDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).createDiscount(requestParameters.agreementId, requestParameters.discount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a discount
     * @param {DiscountApiDeleteDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public deleteDiscount(requestParameters: DiscountApiDeleteDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).deleteDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get discount by id
     * @param {DiscountApiGetDiscountByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public getDiscountById(requestParameters: DiscountApiGetDiscountByIdRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).getDiscountById(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of discounts
     * @param {DiscountApiGetDiscountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public getDiscounts(requestParameters: DiscountApiGetDiscountsRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).getDiscounts(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publish a discount
     * @param {DiscountApiPublishDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public publishDiscount(requestParameters: DiscountApiPublishDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).publishDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a discount ready to be tested
     * @param {DiscountApiTestDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public testDiscount(requestParameters: DiscountApiTestDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).testDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unpublish a discount making it a draft
     * @param {DiscountApiUnpublishDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public unpublishDiscount(requestParameters: DiscountApiUnpublishDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).unpublishDiscount(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a discount
     * @param {DiscountApiUpdateDiscountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public updateDiscount(requestParameters: DiscountApiUpdateDiscountRequest, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).updateDiscount(requestParameters.agreementId, requestParameters.discountId, requestParameters.discount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiscountBucketLoadingProgressApi - axios parameter creator
 * @export
 */
export const DiscountBucketLoadingProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the loading progress for the last bucket of codes of a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountBucketCodeLoadingProgess: async (agreementId: string, discountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDiscountBucketCodeLoadingProgess', 'agreementId', agreementId)
            // verify required parameter 'discountId' is not null or undefined
            assertParamExists('getDiscountBucketCodeLoadingProgess', 'discountId', discountId)
            const localVarPath = `/agreements/{agreementId}/discounts/{discountId}/bucket-loading-progress`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"discountId"}}`, encodeURIComponent(String(discountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountBucketLoadingProgressApi - functional programming interface
 * @export
 */
export const DiscountBucketLoadingProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountBucketLoadingProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the loading progress for the last bucket of codes of a discount
         * @param {string} agreementId Agreement id
         * @param {string} discountId Discount id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountBucketCodeLoadingProgess(agreementId: string, discountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscountBucketCodeLoadingProgess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountBucketCodeLoadingProgess(agreementId, discountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountBucketLoadingProgressApi.getDiscountBucketCodeLoadingProgess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountBucketLoadingProgressApi - factory interface
 * @export
 */
export const DiscountBucketLoadingProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountBucketLoadingProgressApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the loading progress for the last bucket of codes of a discount
         * @param {DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountBucketCodeLoadingProgess(requestParameters: DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiscountBucketCodeLoadingProgess> {
            return localVarFp.getDiscountBucketCodeLoadingProgess(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDiscountBucketCodeLoadingProgess operation in DiscountBucketLoadingProgressApi.
 * @export
 * @interface DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest
 */
export interface DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgess
     */
    readonly agreementId: string

    /**
     * Discount id
     * @type {string}
     * @memberof DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgess
     */
    readonly discountId: string
}

/**
 * DiscountBucketLoadingProgressApi - object-oriented interface
 * @export
 * @class DiscountBucketLoadingProgressApi
 * @extends {BaseAPI}
 */
export class DiscountBucketLoadingProgressApi extends BaseAPI {
    /**
     * 
     * @summary Get the loading progress for the last bucket of codes of a discount
     * @param {DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountBucketLoadingProgressApi
     */
    public getDiscountBucketCodeLoadingProgess(requestParameters: DiscountBucketLoadingProgressApiGetDiscountBucketCodeLoadingProgessRequest, options?: RawAxiosRequestConfig) {
        return DiscountBucketLoadingProgressApiFp(this.configuration).getDiscountBucketCodeLoadingProgess(requestParameters.agreementId, requestParameters.discountId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a document
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument: async (agreementId: string, documentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('deleteDocument', 'agreementId', agreementId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('deleteDocument', 'documentType', documentType)
            const localVarPath = `/agreements/{agreementId}/documents/{documentType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get documents
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getDocuments', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/documents`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a document
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument: async (agreementId: string, documentType: string, document: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('uploadDocument', 'agreementId', agreementId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadDocument', 'documentType', documentType)
            // verify required parameter 'document' is not null or undefined
            assertParamExists('uploadDocument', 'document', document)
            const localVarPath = `/agreements/{agreementId}/documents/{documentType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a document
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocument(agreementId: string, documentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(agreementId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.deleteDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get documents
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocuments(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Documents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocuments(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload a document
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {File} document 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocument(agreementId: string, documentType: string, document: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocument(agreementId, documentType, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.uploadDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a document
         * @param {DocumentApiDeleteDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocument(requestParameters: DocumentApiDeleteDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDocument(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get documents
         * @param {DocumentApiGetDocumentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocuments(requestParameters: DocumentApiGetDocumentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Documents> {
            return localVarFp.getDocuments(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a document
         * @param {DocumentApiUploadDocumentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocument(requestParameters: DocumentApiUploadDocumentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.uploadDocument(requestParameters.agreementId, requestParameters.documentType, requestParameters.document, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDocument operation in DocumentApi.
 * @export
 * @interface DocumentApiDeleteDocumentRequest
 */
export interface DocumentApiDeleteDocumentRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiDeleteDocument
     */
    readonly agreementId: string

    /**
     * Document type
     * @type {string}
     * @memberof DocumentApiDeleteDocument
     */
    readonly documentType: string
}

/**
 * Request parameters for getDocuments operation in DocumentApi.
 * @export
 * @interface DocumentApiGetDocumentsRequest
 */
export interface DocumentApiGetDocumentsRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiGetDocuments
     */
    readonly agreementId: string
}

/**
 * Request parameters for uploadDocument operation in DocumentApi.
 * @export
 * @interface DocumentApiUploadDocumentRequest
 */
export interface DocumentApiUploadDocumentRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentApiUploadDocument
     */
    readonly agreementId: string

    /**
     * Document type
     * @type {string}
     * @memberof DocumentApiUploadDocument
     */
    readonly documentType: string

    /**
     * 
     * @type {File}
     * @memberof DocumentApiUploadDocument
     */
    readonly document: File
}

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @summary Delete a document
     * @param {DocumentApiDeleteDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public deleteDocument(requestParameters: DocumentApiDeleteDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).deleteDocument(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get documents
     * @param {DocumentApiGetDocumentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocuments(requestParameters: DocumentApiGetDocumentsRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getDocuments(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a document
     * @param {DocumentApiUploadDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadDocument(requestParameters: DocumentApiUploadDocumentRequest, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).uploadDocument(requestParameters.agreementId, requestParameters.documentType, requestParameters.document, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentTemplateApi - axios parameter creator
 * @export
 */
export const DocumentTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download a document template
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentTemplate: async (agreementId: string, documentType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('downloadDocumentTemplate', 'agreementId', agreementId)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('downloadDocumentTemplate', 'documentType', documentType)
            const localVarPath = `/agreements/{agreementId}/document-templates/{documentType}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentTemplateApi - functional programming interface
 * @export
 */
export const DocumentTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download a document template
         * @param {string} agreementId Agreement id
         * @param {string} documentType Document type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDocumentTemplate(agreementId: string, documentType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDocumentTemplate(agreementId, documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentTemplateApi.downloadDocumentTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentTemplateApi - factory interface
 * @export
 */
export const DocumentTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Download a document template
         * @param {DocumentTemplateApiDownloadDocumentTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDocumentTemplate(requestParameters: DocumentTemplateApiDownloadDocumentTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDocumentTemplate(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for downloadDocumentTemplate operation in DocumentTemplateApi.
 * @export
 * @interface DocumentTemplateApiDownloadDocumentTemplateRequest
 */
export interface DocumentTemplateApiDownloadDocumentTemplateRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof DocumentTemplateApiDownloadDocumentTemplate
     */
    readonly agreementId: string

    /**
     * Document type
     * @type {string}
     * @memberof DocumentTemplateApiDownloadDocumentTemplate
     */
    readonly documentType: string
}

/**
 * DocumentTemplateApi - object-oriented interface
 * @export
 * @class DocumentTemplateApi
 * @extends {BaseAPI}
 */
export class DocumentTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Download a document template
     * @param {DocumentTemplateApiDownloadDocumentTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentTemplateApi
     */
    public downloadDocumentTemplate(requestParameters: DocumentTemplateApiDownloadDocumentTemplateRequest, options?: RawAxiosRequestConfig) {
        return DocumentTemplateApiFp(this.configuration).downloadDocumentTemplate(requestParameters.agreementId, requestParameters.documentType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GeolocationTokenApi - axios parameter creator
 * @export
 */
export const GeolocationTokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get token for geolocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeolocationToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/geolocation-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeolocationTokenApi - functional programming interface
 * @export
 */
export const GeolocationTokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeolocationTokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get token for geolocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGeolocationToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeolocationToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGeolocationToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeolocationTokenApi.getGeolocationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeolocationTokenApi - factory interface
 * @export
 */
export const GeolocationTokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeolocationTokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Get token for geolocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGeolocationToken(options?: RawAxiosRequestConfig): AxiosPromise<GeolocationToken> {
            return localVarFp.getGeolocationToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GeolocationTokenApi - object-oriented interface
 * @export
 * @class GeolocationTokenApi
 * @extends {BaseAPI}
 */
export class GeolocationTokenApi extends BaseAPI {
    /**
     * 
     * @summary Get token for geolocation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GeolocationTokenApi
     */
    public getGeolocationToken(options?: RawAxiosRequestConfig) {
        return GeolocationTokenApiFp(this.configuration).getGeolocationToken(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HelpApi - axios parameter creator
 * @export
 */
export const HelpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send an help request
         * @param {string} agreementId Agreement id
         * @param {HelpRequest} helpRequest Help request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpRequest: async (agreementId: string, helpRequest: HelpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('sendHelpRequest', 'agreementId', agreementId)
            // verify required parameter 'helpRequest' is not null or undefined
            assertParamExists('sendHelpRequest', 'helpRequest', helpRequest)
            const localVarPath = `/agreements/{agreementId}/help`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(helpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpApi - functional programming interface
 * @export
 */
export const HelpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send an help request
         * @param {string} agreementId Agreement id
         * @param {HelpRequest} helpRequest Help request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendHelpRequest(agreementId: string, helpRequest: HelpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendHelpRequest(agreementId, helpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpApi.sendHelpRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelpApi - factory interface
 * @export
 */
export const HelpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelpApiFp(configuration)
    return {
        /**
         * 
         * @summary Send an help request
         * @param {HelpApiSendHelpRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpRequest(requestParameters: HelpApiSendHelpRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendHelpRequest(requestParameters.agreementId, requestParameters.helpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for sendHelpRequest operation in HelpApi.
 * @export
 * @interface HelpApiSendHelpRequestRequest
 */
export interface HelpApiSendHelpRequestRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof HelpApiSendHelpRequest
     */
    readonly agreementId: string

    /**
     * Help request
     * @type {HelpRequest}
     * @memberof HelpApiSendHelpRequest
     */
    readonly helpRequest: HelpRequest
}

/**
 * HelpApi - object-oriented interface
 * @export
 * @class HelpApi
 * @extends {BaseAPI}
 */
export class HelpApi extends BaseAPI {
    /**
     * 
     * @summary Send an help request
     * @param {HelpApiSendHelpRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HelpApi
     */
    public sendHelpRequest(requestParameters: HelpApiSendHelpRequestRequest, options?: RawAxiosRequestConfig) {
        return HelpApiFp(this.configuration).sendHelpRequest(requestParameters.agreementId, requestParameters.helpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationsDataApi - axios parameter creator
 * @export
 */
export const OrganizationsDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of operators by referent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/referent-organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsDataApi - functional programming interface
 * @export
 */
export const OrganizationsDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of operators by referent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Organizations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsDataApi.getOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsDataApi - factory interface
 * @export
 */
export const OrganizationsDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsDataApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of operators by referent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(options?: RawAxiosRequestConfig): AxiosPromise<Organizations> {
            return localVarFp.getOrganizations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsDataApi - object-oriented interface
 * @export
 * @class OrganizationsDataApi
 * @extends {BaseAPI}
 */
export class OrganizationsDataApi extends BaseAPI {
    /**
     * 
     * @summary Get list of operators by referent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsDataApi
     */
    public getOrganizations(options?: RawAxiosRequestConfig) {
        return OrganizationsDataApiFp(this.configuration).getOrganizations(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a profile
         * @param {string} agreementId Agreement id
         * @param {CreateProfile} profile Profile to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile: async (agreementId: string, profile: CreateProfile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createProfile', 'agreementId', agreementId)
            // verify required parameter 'profile' is not null or undefined
            assertParamExists('createProfile', 'profile', profile)
            const localVarPath = `/agreements/{agreementId}/profile`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a profile
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getProfile', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/profile`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a profile
         * @param {string} agreementId Agreement id
         * @param {UpdateProfile} profile Profile to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (agreementId: string, profile: UpdateProfile, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('updateProfile', 'agreementId', agreementId)
            // verify required parameter 'profile' is not null or undefined
            assertParamExists('updateProfile', 'profile', profile)
            const localVarPath = `/agreements/{agreementId}/profile`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserRole required
            await setApiKeyToObject(localVarHeaderParameter, "X-CGN-USER-ROLE", configuration)

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a profile
         * @param {string} agreementId Agreement id
         * @param {CreateProfile} profile Profile to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfile(agreementId: string, profile: CreateProfile, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfile(agreementId, profile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.createProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a profile
         * @param {string} agreementId Agreement id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a profile
         * @param {string} agreementId Agreement id
         * @param {UpdateProfile} profile Profile to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(agreementId: string, profile: UpdateProfile, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(agreementId, profile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a profile
         * @param {ProfileApiCreateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfile(requestParameters: ProfileApiCreateProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.createProfile(requestParameters.agreementId, requestParameters.profile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a profile
         * @param {ProfileApiGetProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(requestParameters: ProfileApiGetProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.getProfile(requestParameters.agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a profile
         * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.updateProfile(requestParameters.agreementId, requestParameters.profile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiCreateProfileRequest
 */
export interface ProfileApiCreateProfileRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof ProfileApiCreateProfile
     */
    readonly agreementId: string

    /**
     * Profile to create
     * @type {CreateProfile}
     * @memberof ProfileApiCreateProfile
     */
    readonly profile: CreateProfile
}

/**
 * Request parameters for getProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiGetProfileRequest
 */
export interface ProfileApiGetProfileRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof ProfileApiGetProfile
     */
    readonly agreementId: string
}

/**
 * Request parameters for updateProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateProfileRequest
 */
export interface ProfileApiUpdateProfileRequest {
    /**
     * Agreement id
     * @type {string}
     * @memberof ProfileApiUpdateProfile
     */
    readonly agreementId: string

    /**
     * Profile to update
     * @type {UpdateProfile}
     * @memberof ProfileApiUpdateProfile
     */
    readonly profile: UpdateProfile
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Create a profile
     * @param {ProfileApiCreateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public createProfile(requestParameters: ProfileApiCreateProfileRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).createProfile(requestParameters.agreementId, requestParameters.profile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a profile
     * @param {ProfileApiGetProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getProfile(requestParameters: ProfileApiGetProfileRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getProfile(requestParameters.agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a profile
     * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfile(requestParameters.agreementId, requestParameters.profile, options).then((request) => request(this.axios, this.basePath));
    }
}



